const POSTHOG_ACTIVITY_BASE_URL = 'https://eu.posthog.com/project/168392/activity/explore';

export function buildPosthogUserActivityUrl(userId: string): string {
  const query = {
    kind: 'DataTableNode',
    full: true,
    source: {
      kind: 'EventsQuery',
      select: [
        '*',
        'event',
        'person_display_name -- Person',
        'coalesce(properties.$current_url, properties.$screen_name) -- Url / Screen',
        'properties.$lib',
        'timestamp',
      ],
      orderBy: ['timestamp DESC'],
      after: '-7d',
      filterTestAccounts: true,
      properties: [
        {
          key: 'distinct_id',
          value: [userId],
          operator: 'exact',
          type: 'event_metadata',
        },
      ],
    },
    propertiesViaUrl: true,
    showSavedQueries: true,
    showPersistentColumnConfigurator: true,
    showPropertyFilter: true,
  };

  return `${POSTHOG_ACTIVITY_BASE_URL}#q=${encodeURIComponent(JSON.stringify(query))}`;
}
